export default __webpack_public_path__ + "static/media/p3.4786bd92.jpg";